import { ROUTES } from "@is/constants/routes";

export const USER_ACTIVITY_EXPIRED_TIME = 1000 * 60 * 5;
export const ACTIVITY_MODAL_EXPIRED_TIME = 1000 * 60;

// 45 seconds after checking the activity
export const USER_ACTIVITY_EXPIRED_TIME_ENTRY_VIEW = 1000 * 45;

export const CHECK_ACTIVITY_INTERVAL = 1000;

export const STYLE_NOT_EXIST_MODAL_EXPIRED_TIME = 1000 * 30;
export const STYLE_NOT_EXIST_BUTTON_EXPIRED_TIME = 1000 * 10;
export const STYLE_NOT_EXIST_BUTTON_ACTIVATION_TIME = 1000 * 20;

export const CONFIRMED_ORDER_VIEW_EXPIRED_TIME = 1000 * 10;

export const DISABLE_USER_ACTIVITY_FOR_ROUTES = [
  ROUTES.Bestseller as string,
  ROUTES.WelcomeView as string,
  ROUTES.Registration as string,
  ROUTES.PreloadView as string,
  ROUTES.ErrorView as string,
  ROUTES.ErrorExpiredView as string,
];
